module.exports = __webpack_public_path__ + "img/cash-stack.83a5c8fc.svg";